module.exports = __webpack_public_path__ + "img/icon_chain.062125b3.png";